import { logg } from '@/util/logg';

export function handleStateChangeFeedback(prevState, newState, patch) {
	if (!patch) return;

	const prevPlayers = prevState?.playerStateArray || [];
	const newPlayers = newState?.playerStateArray || [];

	newPlayers.forEach((player, idx) => {
		const prevPlayer = prevPlayers[idx] || {};
		if (player.energy !== prevPlayer.energy) {
			const diff = player.energy - (prevPlayer.energy || 0);
			showEnergyChangeAnimation(player.playerId, diff);
		}
	});
}

function showEnergyChangeAnimation(playerId, diff) {
	const msg =
		diff > 0
			? `Player ${playerId} gained ${diff} energy!`
			: `Player ${playerId} lost ${Math.abs(diff)} energy!`;

	logg(msg);
	// Optionally, trigger animation here
}
